export default __webpack_public_path__ + "static/media/013-m.87ddd236.svg";